var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",on:{"click":_vm.handleClose}},[_c('div',{staticClass:"modal_content",class:_vm.animationState ? 'animation-on' : 'animation-off',style:([{
    minHeight: `${_vm.ModalBase.boxHight}`,
    width: `${_vm.ModalBase.boxWidth}`, backgroundColor: `${_vm.ModalBase.boxBgc}`
}]),on:{"click":function($event){$event.stopPropagation();return _vm.changeInside.apply(null, arguments)}}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }